// extracted by mini-css-extract-plugin
module.exports = {"forgot-password-form":"styles_forgot-password-form__1n9QR","description":"styles_description__3HHy-","email-field":"styles_email-field__IMgpO","buttons":"styles_buttons__3N9Kn"};